<template id="app-user-profile">
  <div>
    <md-menu
      class="menu"
      md-align-trigger
      :md-close-on-click="true"
      :md-close-on-select="true"
      md-direction="top-end"
      md-size="auto"
    >
      <strong style="color: white">{{ userDisplayName }}</strong>
      <md-button class="md-icon-button" md-menu-trigger>
        <md-icon>person</md-icon>
      </md-button>
      <md-menu-content class="menuContent">
        <div class="author-card">
          <div class="author-card-info">
            <span v-if="!userName">Welcome</span>
            <div v-if="userName" id="menuLogo">
              <img src="/assets/image/logoAugmeditWhite.svg" />
            </div>
            <span>
              <strong>{{ userDisplayName }}</strong>
            </span>
            <span>{{ userName }}</span>
            <md-button v-if="userName" class="md-dense" @click="signOut">
              Sign Out
            </md-button>
            <md-button class="md-dense" @click="showAbout = true">
              About</md-button
            ><md-button class="md-dense" @click="openUserGuide()">
              User Guide </md-button
            ><md-button class="md-dense" @click="showUserFeedback = true">
              Report Feedback
            </md-button>
            <md-button
              v-if="
                allowedFeatureToggles.includes(featureToggles.AUDIT_READER) ||
                isAdmin
              "
              class="md-dense"
              ><router-link to="/admin/audit"
                >Audit Data</router-link
              ></md-button
            >
          </div>
        </div>
      </md-menu-content>
    </md-menu>
    <md-dialog :md-active.sync="showAbout">
      <md-dialog-title
        >About LumiNE{{ isUsSite() ? " US" : "" }}</md-dialog-title
      >
      <md-dialog-content class="aboutPopup">
        <app-about-page :region="isUsSite() ? 'us' : 'eu'"></app-about-page>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="showAbout = false"
          >OK</md-button
        >
      </md-dialog-actions> </md-dialog
    ><md-dialog class="feedbackDialog" :md-active.sync="showUserFeedback">
      <md-dialog-title
        >Report Feedback
        <md-icon class="feedbackIcon">edit_note</md-icon>
      </md-dialog-title>
      <md-dialog-content class="feedbackPopup">
        <app-feedback-page ref="feedbackContent" />
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary md-raised" @click="submitUserFeedback()"
          >Send</md-button
        ><md-button class="md-primary" @click="showUserFeedback = false"
          >Cancel</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import appSettings from "./appSettings";
import CountryVerification from "@/classes/CountryVerification";
import appAboutPage from "./appAboutPage.vue";
import appFeedbackPage from "./appFeedbackPage.vue";
import featureToggles from "../enums/FeatureToggles.js";

export default {
  name: "AppUserProfile",
  components: {
    "app-about-page": appAboutPage,
    "app-feedback-page": appFeedbackPage,
  },
  data: () => ({
    showAbout: false,
    showUserFeedback: false,
    featureToggles: featureToggles,
  }),
  computed: {
    ...mapState([
      "user",
      "idToken",
      "selectedGroup",
      "selectedAsset",
      "allowedFeatureToggles",
    ]),
    ...mapGetters(["lastBreadcrumb", "isHome", "isAdmin"]),
    userName() {
      return this.user ? this.user.userName : "";
    },
    userDisplayName() {
      return this.user ? this.user.displayName : "";
    },
  },

  methods: {
    ...mapActions(["fetchAzure", "postAzure", "signOut"]),
    isUsSite() {
      return CountryVerification.isUsSite();
    },
    submitUserFeedback() {
      this.$refs.feedbackContent.submitUserFeedback();
      this.showUserFeedback = false;
    },
    openUserGuide() {
      const environment = CountryVerification.getEnvironment();
      const url = `${appSettings.userguideurl}?environment=${
        environment === "localhost" ? "test" : environment
      }&access_token=${this.idToken}`;
      window.open(url).focus();
    },
  },
};
</script>
<style scoped>
.aboutPopup {
  width: 700px;
  height: 1000px;
}
#menuLogo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 12px;
}
#menuLogo img {
  width: 50px;
}
.feedbackPopup {
  /* override main.css */
  height: auto;
  width: auto;
}
.menu {
  line-height: 40px;
  margin-top: 3px;
}
.menuContent {
  margin-top: 50px;
  border-radius: 20px;
  width: 100%;
}

.md-dialog-title {
  text-align: center;
}
.md-dialog-container {
  max-height: 90%;
}
</style>
